import { render, staticRenderFns } from "./HeaderListWithoutBtn.vue?vue&type=template&id=d7146918&"
var script = {}
import style0 from "./HeaderListWithoutBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports